export default __webpack_public_path__ + "static/media/ban-desktop-image-10.d9193a6a.jpg";